<template>
  <div style="display: flex;height: 100%;">
    <div class="left">
      <img src="../../assets/phone.png" alt="">
      <div style="position:relative;margin-bottom: 20px;">
        <img :src="img.url" style="">
        <!--        <div v-for="(val,key) in img.item" :key="key" style="{'top':val;}">-->
        <!--         {{val.title}}-->
        <!--        </div>-->
        <template v-for="(val,key) in img.item">
          <div :key="key"
               :style="{'left':val.x_axis+'%','top':val.y_axis+'%','position': 'absolute','width':val.width>0 ? val.width+'%' : 'auto','height':val.height>0 ? val.height+'%' : 'auto'}"
               :class="val.is_show == 1 ? 'point pad':'point'">{{ val.is_show == 1 ? val.title : '' }}
          </div>
        </template>
      </div>
    </div>
    <div class="right">
      <div class="mb-10 text" style="display: flex">
        <div>
          <div class="upload" @click="is_img=true">
            <img :src="img.url">
          </div>
          <div style="font-size: 13px;">点击图片更换</div>
        </div>
        <div>
          <el-button type="primary" @click="addpoint">添加锚点</el-button>
        </div>
      </div>
      <div style="height:450px;overflow: auto;">
        <template v-for="(val,key) in img.item">
          <div :key="key" class="point_list">
            <div class="iconfont icon-close-circle" @click="del(key)"></div>
            <el-form label-width="80px" :model="val" :rules="rules">
              <el-form-item label="类型" prop="">
                <template>
                  <el-radio-group v-model="val.type">
                    <el-radio label="text">文本</el-radio>
                    <el-radio label="video">视频</el-radio>
                    <el-radio label="page">页面链接</el-radio>
                  </el-radio-group>
                </template>
              </el-form-item>
              <el-form-item label="位置" prop="">
                <el-radio v-model="val.is_show" label="1">默认</el-radio>
                <el-radio v-model="val.is_show" label="2">透明区域</el-radio>
                <el-input v-model="val.x_axis" placeholder="%" style="width: 140px;margin-right: 10px;" type="number"
                          min='0' max='100'>
                  <template slot="prepend">距左</template>
                </el-input>
                <el-input v-model="val.y_axis" placeholder="%" style="width: 140px;" type="number" min='0'
                          max='100'>
                  <template slot="prepend">距上
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item :label="val.is_show==1 ? '标题' : ''" prop="">
                <el-input v-if="val.is_show==1" v-model="val.title" placeholder="标题"
                          style="width: 170px;margin-right: 22px;"></el-input>
                <el-input v-model="val.width" placeholder="%" style="width: 140px;margin-right: 10px;" type="number"
                          min='0' max="100">
                  <template slot="prepend">宽度</template>
                </el-input>
                <el-input v-model="val.height" placeholder="%" style="width: 140px;" type="number" min='0' max="100">
                  <template
                      slot="prepend">高度
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item label="页面链接" prop="" v-if="val.type=='page'">
                <el-select v-model="val.page_id" placeholder="请选择微页">
                  <el-option
                      v-for="it in page_list"
                      :key="it.id"
                      :label="it.title"
                      :value="it.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="视频" prop="video" v-if="val.type=='video'">
                <!--                  <vue-upload is-server v-model="val.video" ></vue-upload>-->
                <el-upload
                    class="avatar-uploader" :show-file-list="false"
                    :http-request="video_upload" :data="{k:key}" accept="video/*">
                  <!--                    <img  :src="val.video" class="avatar">-->
                  <video v-if="val.video" :src="val.video" class="avatar"></video>
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="文本" prop="" v-if="val.type=='text'">
                <f-edit v-model="val.text" :isServer="false" :width="480"></f-edit>
              </el-form-item>
            </el-form>
          </div>
        </template>
      </div>
    </div>
    <layer-pop title="选择图片" @close="is_img=false" v-if="is_img">
      <upload-img @submit="img_choose"></upload-img>
    </layer-pop>
  </div>
</template>

<script>
import FEdit from '@/components/form/f-edit'
import LayerPop from "@/components/layer-pop.vue";
import UploadImg from "@/components/upload/upload-img.vue";
export default {
  name: "img_edit",
  components: {UploadImg, LayerPop, FEdit},
  // model:{prop:'img' ,event:'img_submit'},
  props: {
    img: {
      type: Object, default: function () {
        return {}
      }
    },
  },
  data() {
    return {
      rules: {
        title: [{required: true, message: '请填写', trigger: 'blur'}],
        type: [{required: true, message: '请填写', trigger: 'blur'}],
      },
      page_list: [],
      // data:{type:'page',title:'1111',x_axis:'0',y_axis:'0',page:'',page_id:'',video:''},
      // item:[{type:'page',title:'1111',x_axis:'0',y_axis:'0',page:'',page_id:'',video:''},{type:'page',title:'222',x_axis:'0',y_axis:'0',page:'',page_id:'',video:''}]
      dir: [],
      is_img:false,
    }
  },
  mounted: async function () {
    try {
      let uid = this.user.uid;
      if (uid) {
        await this.get_list(uid);
      } else {
        // this.post.pid =  [];
      }
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    get_list: async function (uid) {
      try {
        let query = this.$route.query;
        let id = query.id ? query.id : 0;
        let res = await this.$_api.page('list', {uid: uid, page_id: id});
        if (res.errcode == 0) {
          console.log(res.list);
          this.page_list = res.list;
          // this.content = res.post.content;
        }
      } catch (e) {
        console.log(e);
      }
    },
    addpoint: function () {
      let item = {type: 'text', title: '标题', is_show: '1', x_axis: '0', y_axis: '0', page: '', page_id: '', video: '', text: '', width: '', height: ''};
      this.img.item.push(item);
    },
    del: async function (key) {
      let res = await this.$_confirm('确认删除？', '删除',);
      if (res) {
        this.img.item.splice(key, 1);
      }
    },
    img_choose:function (e){
      this.img.url = e.url;
      this.is_img = false;
    },
    submit: function () {
      this.$emit('img_submit', this.img);
    },
    video_upload: async function (e) {
      try {
        console.log(e.file);
        // console.log(this.content[e.file.data]);
        if (e.file) {
          this.$_showLoading();
          let res = await this.$_api.upload(e.file, 'file','',this.user.uid);
          this.$_hideLoading();
          this.$_showToast(res.errmsg, res.style);
          this.img.item[e.data.k].video = res.url;
        }
      } catch (e) {
        console.log(e);
        return false;
      }
    },
  }
}
</script>

<style scoped>
.point {
  position: absolute;
  text-align: center;
  background: rgba(38, 34, 33, .3);
  border-radius: 20px;
  font-size: 12px;
  color: #ffffff;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  /*transform: translateX(8px) translateY(-50%);*/
}
.pad {
  padding: 0 6px;
}
.point::after {
  left: -12px;
  content: "";
  display: block;
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(0, 0, 0, .2);
  top: 50%;
  transform: translateY(-50%);
}
.point_list {
  border: 1px solid #dcdfe6;
  margin-bottom: 10px;
  border-radius: 5px;
  position: relative;
}
.upload {
  width: 120px;
  height: 140px;
  line-height: 140px;
  border-radius: 5px;
  border: 1px solid #dcdfe6;
  text-align: center;
  cursor: pointer;
  margin-right: 10px;
}
.upload img {
  width: 100%;
  height: 100%;
  object-fit: contain
}
.icon-close-circle {
  color: #dd524d;
  position: absolute;
  right: -2px;
  top: -2px;
  font-size: 26px;
  z-index: 999;
  cursor: pointer;
}
.left {
  width: 500px;
  background: #f6f8f9;
  padding: 2px;
  margin-right: 20px;
}
.left img {
  width: 100%;
}
.right {
  flex: 1;
}
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 150px;
  height: 150px;
}
.avatar-uploader:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
</style>